import { ReactElement, useMemo } from 'react';
import { CircularProgress } from '@mui/material';

import { DialogImportOrdersFromIntegrationProps } from './types';
import DialogImportOrdersFromIntegrationProvider, {
  useDialogImportOrdersFromIntegrationContext,
} from './DialogImportOrdersFromIntegrationContext';
import DialogImportOrdersFromIntegrationContent from './DialogImportOrdersFromIntegrationContent';
import {
  DialogImportOrdersFromIntegrationContainer,
  DialogImportOrdersFromIntegrationLoadingContainer,
} from './styles';

const DialogImportOrdersFromIntegration = ({
  open,
  onClose,
}: Omit<
  DialogImportOrdersFromIntegrationProps,
  'onSubmitSuccess' | 'onEmptyIntegrations'
>): ReactElement => {
  const {
    logisticsZones: { loading: loadingLogisticsZonez },
    currentIntegrations: { loading: loadingCurrentIntegrations },
  } = useDialogImportOrdersFromIntegrationContext();

  const initialLoading = useMemo(
    () => loadingLogisticsZonez || loadingCurrentIntegrations,
    [loadingCurrentIntegrations, loadingLogisticsZonez],
  );

  return (
    <DialogImportOrdersFromIntegrationContainer
      open={open}
      onClose={onClose}
      maxWidth="sm"
    >
      {initialLoading && (
        <DialogImportOrdersFromIntegrationLoadingContainer>
          <CircularProgress color="primary" disableShrink size={80} />
        </DialogImportOrdersFromIntegrationLoadingContainer>
      )}

      {!initialLoading && (
        <DialogImportOrdersFromIntegrationContent onClose={onClose} />
      )}
    </DialogImportOrdersFromIntegrationContainer>
  );
};

const WrappedDialogImportOrdersFromIntegration = ({
  open,
  onClose,
  onSubmitSuccess,
  onEmptyIntegrations,
}: DialogImportOrdersFromIntegrationProps): ReactElement | null => {
  if (!open) return null;

  return (
    <DialogImportOrdersFromIntegrationProvider
      onSubmitSuccess={onSubmitSuccess}
      onClose={onClose}
      onEmptyIntegrations={onEmptyIntegrations}
    >
      <DialogImportOrdersFromIntegration open={open} onClose={onClose} />
    </DialogImportOrdersFromIntegrationProvider>
  );
};

export default WrappedDialogImportOrdersFromIntegration;
